export const headerLogo = {
  logoAlt: 'Virgin Media',
  logoHref: 'https://www.virginmedia.com/ ',
  logoAsset: 'logos/white@3x.png',
};
